import type {
  AssignWorkOrderCommitPayload,
  AssignWorkOrderDraft,
  WorkOrderAssignmentRow,
} from "../contract"

export const assignWorkOrderPayload = (
  row: WorkOrderAssignmentRow,
  draft: AssignWorkOrderDraft,
): AssignWorkOrderCommitPayload => {
  if (!draft.workOrderId) throw new Error("Für die Auftragszuordnung fehlt die WorkOrder-ID.")

  return {
    decision: "use_existing",
    work_order_id: draft.workOrderId,
    schedule_event_id: row.scheduleEventId,
  }
}
